import className from "classnames";
import {
  GOVGR_BTN,
  GOVGR_BTN_PRIMARY,
  GOVGR_BTN_SECONDARY,
  GOVGR_BTN_WARNING,
  GOVGR_BTN_DISABLED,
  GOVGR_BTN_CTA,
  GOVGR_ARROW__RIGHT,
  GOVGR_LINK,
} from "../../conf/styles/ButtonClassConf";

import { LINK, PRIMARY, SECONDARY, WARNING } from "./buttonConstants";

// buttonText props is used to show the text of the button
// variant prop is used to calculate the variant of button Variants are PRIMARY,SECONDARY,WARNING
// hasImage props is used to display or not the arrow image on button
const GovGrButton = ({
  buttonText = "Select",
  variant = PRIMARY,
  hasImage = false,
  ...props
}) => {
  const getButtonType = (variant) => {
    switch (variant) {
      case PRIMARY:
        return GOVGR_BTN_PRIMARY;

      case SECONDARY:
        return GOVGR_BTN_SECONDARY;

      case WARNING:
        return GOVGR_BTN_WARNING;
      case LINK:
        return GOVGR_BTN_WARNING;

      default:
        return GOVGR_BTN_PRIMARY;
    }
  };

  let ComponentWrapperClass = className(GOVGR_BTN, {
    [GOVGR_BTN_DISABLED]: props?.disabled,
    [GOVGR_BTN_CTA]: hasImage,
    [getButtonType(variant)]: variant,
  });
  let SpanWrapperClass = className(GOVGR_LINK);

  return (
    <>
      {variant !== LINK ? (
        <button
          aria-label={props?.disabled}
          className={`${ComponentWrapperClass} m-0`}
          {...props}
        >
          {buttonText}
          {hasImage && (
            <svg
              viewBox="0 0 24 24"
              className={GOVGR_ARROW__RIGHT}
              focusable="false"
              aria-hidden="true"
            >
              {" "}
              <path d="M8.5,2L6.1,4.3l7.6,7.7l-7.6,7.6L8.5,22l10-10L8.5,2z" />{" "}
            </svg>
          )}
        </button>
      ) : (
        <span
          className={SpanWrapperClass}
          aria-label={props?.disabled}
          {...props}
        >
          {buttonText}
        </span>
      )}
    </>
  );
};

export default GovGrButton;
